import { Box } from '@mui/system';
import React from 'react';

const Account = () => (
                    
    <Box sx={{mt:"30px", width:"50%", margin:'auto'}}>
    
        Full user-directed account functionality has not been implemented yet. Please contact <a href="mailto:azaffos@arizona.edu">Andrew Zaffos</a> for any needed changes to your account such as resetting your password or changing your email.

    </Box>
);

export default Account;
